<template>
    <div>
        <modal
        class="new-modal-default"
        :name="modal_name"
        transition="nice-modal-fade"
        :delay="100"
        :width="800"
        :height="540"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="false"
        style="pointer-events:inherit !important" 
        v-bind:click-to-close="false"
        >
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span class="v-modal-dialog-title v-modal-title">Add/Edit Reminder</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideSelf"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout px-14">
                        <div>
                            <span class="text-secondary fs-14 fw-600 ml-2">Reminder Name</span>
                            <textarea-autosize class="digi-textarea white-background bordered mt-5" v-model="lead_reminder.name" placeholder="Follow Up Discussion" style="height: 8em; overflow: auto;" />
                        </div>
                        <div class="row mt-4">
                            <div class="col-5">
                                <span class="text-secondary fs-14 fw-600 ml-2">Date</span>
                                <date-picker class="meetinfdatetime mx-left calendar-edit-per mr-1 my-4" format="DD/MM/YYYY" type="date" lang="en" v-model="lead_reminder.event_schedule.start_date" :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                <span class="text-secondary fs-14 fw-600 ml-2">Time</span>
                                <div class="d-flex align-items-center">
                                    <date-picker class="meetinfdatetime no-icon calendar-edit-per mr-1 my-4" format="hh:mm a" type="time" placeholder="HH:MM" lang="en" v-model="lead_reminder.event_schedule.start_time" :clearable="false" :editable="false" :minute-step="1" confirm confirm-text="APPLY"></date-picker>
                                    <span style="position:absolute;right:29px !important">
                                        <img src="/static/images/down-arrow-grey.svg" alt="">
                                    </span>
                                </div>
                            </div>
                            <div class="col-1"></div>
                            <div class="col-6">
                                <span class="text-secondary fs-14 fw-600 ml-2">Notify Before</span>
                                <div class="mt-4" style="border: 1px solid #676767; border-radius: 5px; padding: 10px;">
                                    <div class="d-flex align-items-center mt-1">
                                        <span>Before</span>
                                        <input class="text-center mx-2 pr-5" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model="lead_reminder.remind_before[0].number" name="number1" style="min-height: 40px; width: 55px; border: solid 1px #d7dae2; border-radius: 5px;" />
                                        <div class="d-flex flex-column" style="position: absolute; margin-left: 82px;">
                                            <i class="icon icon-arrow-down-drop pointer" style="transform: rotate(180deg); line-height: 12px;" @click="lead_reminder.remind_before[0].number += 1"></i>
                                            <i class="icon icon-arrow-down-drop pointer" style="line-height: 12px;" @click="lead_reminder.remind_before[0].number > 0 ? lead_reminder.remind_before[0].number -= 1 : ''"></i>
                                        </div>
                                        <multiselect class="diginew-multiselect-lightgrey no-default-icon down-arrow" :clearable="false" :filterable="true" :options="['Days', 'Minutes', 'Hours']" name="text1" v-model="lead_reminder.remind_before[0].gap"></multiselect>
                                    </div>
                                    <div class="d-flex align-items-center mt-1">
                                        <span>Before</span>
                                        <input class="text-center mx-2 pr-5" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model="lead_reminder.remind_before[1].number" name="number2" style="min-height: 40px; width: 55px; border: solid 1px #d7dae2; border-radius: 5px;" />
                                        <div class="d-flex flex-column" style="position: absolute; margin-left: 82px;">
                                            <i class="icon icon-arrow-down-drop pointer" style="transform: rotate(180deg); line-height: 12px;" @click="lead_reminder.remind_before[1].number += 1"></i>
                                            <i class="icon icon-arrow-down-drop pointer" style="line-height: 12px;" @click="lead_reminder.remind_before[1].number > 0 ? lead_reminder.remind_before[1].number -= 1 : ''"></i>
                                        </div>
                                        <multiselect class="diginew-multiselect-lightgrey no-default-icon down-arrow" :clearable="false" :filterable="true" :options="['Days', 'Minutes', 'Hours']" name="text2" v-model="lead_reminder.remind_before[1].gap"></multiselect>
                                    </div>
                                    <div class="d-flex align-items-center mt-1">
                                        <span>Before</span>
                                        <input class="text-center mx-2 pr-5" type="text" onkeypress="return event.charCode >= 48 && event.charCode <= 57" v-model="lead_reminder.remind_before[2].number" name="number3" style="min-height: 40px; width: 55px; border: solid 1px #d7dae2; border-radius: 5px;" />
                                        <div class="d-flex flex-column" style="position: absolute; margin-left: 82px;">
                                            <i class="icon icon-arrow-down-drop pointer" style="transform: rotate(180deg); line-height: 12px;" @click="lead_reminder.remind_before[2].number += 1"></i>
                                            <i class="icon icon-arrow-down-drop pointer" style="line-height: 12px;" @click="lead_reminder.remind_before[2].number > 0 ? lead_reminder.remind_before[2].number -= 1 : ''"></i>
                                        </div>
                                        <multiselect class="diginew-multiselect-lightgrey no-default-icon down-arrow" :clearable="false" :filterable="true" :options="['Days', 'Minutes', 'Hours']" name="text3" v-model="lead_reminder.remind_before[2].gap"></multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center align-items-center mt-10">
                            <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #d51650; border: 1px solid #d51650" @click="hideSelf">Cancel</button>
                            <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #008a63; border: 1px solid #008a63" @click="save">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            lead_reminder: {
                event_schedule: {
                    start_date: new Date(),
                    start_time: new Date(),
                },
                event_type: "Leads Event Reminder",
                name: "",
                remind_before: [
                    {
                        gap: "",
                        number: 0
                    },
                    {
                        gap: "",
                        number: 0
                    },
                    {
                        gap: "",
                        number: 0
                    }
                ]
            },
            edit: false,
            is_remind_before_not_filled: false
        }
    },
    props: ["modal_name", "leadreminder", "add_edit_reminder"],
    methods: {
        hideSelf() {
            if(this.lead_reminder.event_schedule.start_date != '' || this.lead_reminder.event_schedule.start_time != "" || this.lead_reminder.name != "") {
                this.$modal.hide(this.modal_name);
                this.$emit("hideReminderPop");
            } else {
                this.lead_reminder.event_schedule.start_date = "";
                this.lead_reminder.event_schedule.start_time = "";
                this.lead_reminder.event_type = "Leads Event Reminder";
                this.lead_reminder.name = "";
                this.lead_reminder.remind_before.forEach(x => {
                    x.gap = "";
                    x.number = 0;
                });
                this.$modal.hide(this.modal_name);
                this.$emit("hideReminderPop");
            }
        },
        save() {
            if (this.add_edit_reminder == 'add') {
                this.$emit("saveReminder", this.lead_reminder);
                // console.log(this.lead_reminder);
                this.$modal.hide(this.modal_name);
            } else if (this.add_edit_reminder == 'edit') {
                this.$emit("editReminderConfirm", this.lead_reminder);
                // console.log(this.lead_reminder);
                this.$modal.hide(this.modal_name);
            }
        }
    },
    mounted() {
        if(this.add_edit_reminder == 'edit') {
            this.lead_reminder = this.leadreminder;
        } else {
            this.lead_reminder = {
                event_schedule: {
                    start_date: new Date(),
                    start_time: new Date(),
                },
                event_type: "Leads Event Reminder",
                name: "",
                remind_before: [
                    {
                        gap: "",
                        number: 0
                    },
                    {
                        gap: "",
                        number: 0
                    },
                    {
                        gap: "",
                        number: 0
                    }
                ]
            }
        }
    },
    // watch: {
    //     leadreminder: function() {
    //         if (this.leadreminder) {
    //             this.lead_reminder = this.leadreminder;
    //             this.edit = true;
    //         }
    //     }
    // }
}
</script>


// WEBPACK FOOTER //
// src/components/CreateLeadsAddEditReminder.vue